module.exports = __webpack_public_path__ + "img/vertical_6_4_7016.134b2d55.png";